import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
var ImageThumbnail = function (_a) {
    var imgSrc = _a.imgSrc, _b = _a.allowDelete, allowDelete = _b === void 0 ? false : _b, classes = _a.classes, _c = _a.icon, icon = _c === void 0 ? null : _c, deleteActionHandle = _a.deleteActionHandle;
    var deleteImage = function () {
        deleteActionHandle();
    };
    return (_jsxs("div", { className: "relative", children: [_jsx("div", { className: "w-[72px] h-[72px] flex items-center justify-center overflow-hidden rounded-[8px] ".concat(classes), children: _jsx("img", { className: "", src: imgSrc, alt: "" }) }), allowDelete && icon != null && (_jsx("span", { onClick: deleteImage, className: "absolute flex items-center justify-center -bottom-2 -right-2 border-2 border-white w-[20px] h-[20px] rounded-full bg-[#EB5757]", children: _jsx("img", { src: icon, alt: "" }) }))] }));
};
export default ImageThumbnail;
